












































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import ModalLayout from '@/components/lfs/Badges/ModalLayout.vue'
import EmptyContactList from '@/components/lfs/Badges/ListItems/EmptyContact.vue'
import {Badge, Contact} from '@/store/modules/lib'
import {uuid} from 'vue-uuid'
import ITrash from '@/components/icons/ITrash.vue'
import IEdit from '@/components/icons/IEdit.vue'
import Search from "@/components/UI/Search.vue";

const resources = namespace("resources")
const forms = namespace('forms')
const dialog = namespace('dialog')
const profile = namespace('profile')

@Component({
  name: 'c-edit-contact',

  components: {
    ModalLayout,
    EmptyContactList,
    'i-trash': ITrash,
    'i-edit': IEdit,
    Search,
  }
})
export default class EditContact extends Vue {
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @dialog.Mutation('SetTitleDialog') protected SetTitleDialog: any
  @dialog.Mutation('SetFormSDialog') protected SetFormSDialog: any
  @resources.Getter('getCountries') protected countries: any
  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @forms.Mutation('setOptions') protected setOptions: any

  @Prop(Object) badge!: Badge
  @Prop({type: [Boolean], default: false}) protected isCurrentCompany!: boolean


  isOpenModal: boolean = false
  contactId: string | null = null

  get contactCategoryList(){
    return [
      {title: this.$t('profile.contacts.phone'), value: 'phone'},
      {title: this.$t('profile.contacts.email'), value: 'email'},
      {title: this.$t('profile.company.site'), value: 'site'},
      {title: this.$t('profile.address.title'), value: 'address', subtitle: this.$t('profile.address.subtitle')},
      {title: this.$t('profile.company.social'), value: 'network'}
    ]
  }
  get networkCategoryList(){
    return [
      {title: 'Facebook', value: 'facebook'},
      {title: 'Instagram', value: 'instagram'},
      {title: 'YouTube', value: 'youtube'},
      {title: 'Twitter', value: 'twitter'},
      {title: 'VK', value: 'vk'},
      {title: 'WhatsApp', value: 'whatsapp'},
      {title: 'Telegram', value: 'telegram'},
      {title: 'Viber', value: 'viber'}
    ]
  }

  title: string = ''
  contactCategory = ''
  phone = ''
  email = ''
  site = ''
  network = {
    value: '',
    type: ''
  }
  address = {
    title: '',
    subtitle: '',
    address: '',
    city: '',
    region: '',
    _country: 'RU',
    postcode: ''
  }
  search:string = ''

  @Watch('isOpenModal')
  isOpenModalChanged(newValue: boolean) {
    if (!newValue) {
      this.resetForm()
      this.contactId = null
    }
  }

  get headers(){
    return [
      { text: this.$t('profile.contacts.table.title'), value: 'title', sortable: false, width: '150' },
      { text: this.$t('profile.contacts.table.data'), value: 'value', sortable: false, width: '100%' },
      { text: '', value: 'edit', sortable: false, width: '56'  },
      { text: '', value: 'delete', sortable: false, width: '56' },
    ]
  }

  get items() {
    this.badge.contacts = this.badge.contacts.map((contact: any) => {
      return {...contact, idType: contact.id + contact.type}
    })
    if(this.badge.locations) {
      this.badge.locations.forEach((location) => {
        location.value = this.printAddress(location)
        location.type = 'address'
      })
      return this.badge.contacts.concat(this.badge.locations)
    } else {
      return this.badge.contacts
    }
  }

  get itemsSearch(){
   if(this.search ==='') return this.items
    return this.items.filter((el:any)=>{return el.value.toLowerCase().includes(this.search.toLocaleLowerCase()) || el.title.toLowerCase().includes(this.search.toLocaleLowerCase())})
  }

  get formTitle() {
    return this.contactId
      ? this.$t('profile.contacts.form.edit_contact')
      : this.$t('profile.contacts.form.add_contact')
  }


  get isSubmitDisabled(): boolean {
    switch (this.contactCategory) {
      case 'phone':
        return !(this.title && this.phone)
        break;
      case 'email':
        return !(this.title && this.email)
        break;
      case 'site':
        return !(this.title && this.site)
        break;
      case 'address':
        return !this.address.title;
        break;
      case 'network':
        return !(this.title && this.network.value && this.network.type)
        break;
      default:
        return true
    }
  }

  resetForm(): void {
    this.title = ''
    this.contactCategory = ''
    this.phone = ''
    this.email = ''
    this.site = ''
    this.network = {
      value: '',
      type: ''
    }
    this.address = {
      subtitle: '',
      title: '',
      address: '',
      city: '',
      region: '',
      _country: 'RU',
      postcode: ''
    }
  }

  openModal(): void {
    let options = {
      badge: this.badge,
      contactId: this.contactId,
      isCurrentCompany: this.isCurrentCompany
    }
    this.setOptions(options)
    this.SetTitleDialog(this.$t('profile.contacts.form.add_contact'))
    this.SetFormSDialog('AddContactForm')
    this.SetFullDialogShow(true)
  }

  closeModal(): void {
    this.isOpenModal = false
    this.contactId = null

    this.title = ''
    this.contactCategory = ''
    this.phone = ''
    this.email = ''
    this.site = ''
    this.network = {
      value: '',
      type: ''
    },
      this.address = {
        subtitle: '',
        title: '',
        address: '',
        city: '',
        region: '',
        _country: 'ru',
        postcode: ''
      }
  }

  onSubmit(): void {
    let contacts: any[] = []
    let contact: any = {}
    if (this.contactCategory === 'network') {
      contact = {
        title: this.title,
        type: this.network.type,
        value: this.network.value
      }
    } else if (this.contactCategory === 'address') {
      contact = {
        ...this.address,
        title: this.address.title,
        type: 'address'
      }
    } else {
      contact = {
        title: this.title,
        type: this.contactCategory,
        value: this[this.contactCategory as keyof EditContact]
      }
    }

    if (this.contactId) {
      if(contact.type === 'address'){
        contacts = this.badge.locations.map(item => {
          if (item.id === this.contactId) {
            item = {...item, ...contact}
          }
          return item
        })
      } else {
        contacts = this.badge.contacts.map(item => {
          if (item.id === this.contactId) {
            item = {...item, ...contact}
          }
          return item
        })
      }
    } else {
      let id = uuid.v1()
      contact.id = id
      if(contact.type === 'address'){
        contacts =  [...this.badge.locations, contact]
      } else {
        contacts = [...this.badge.contacts, contact]
      }
    }

    if(contact.type === 'address'){
      this.$emit('onLocations', contacts)
    } else {
      this.$emit('onChange', {contacts})
    }



    this.closeModal()
  }

  onEdit(contact: any) {
    let options:any = {
      address: {
        title: '',
        subtitle: '',
        address: '',
        city: '',
        region: '',
        _country: 'RU',
        postcode: ''
      },
      network: {
        value: '',
        type: ''
      },
      phone: '',
      email: '',
      site: '',
    }

    this.contactId = contact.id
    if(contact.title) {
      this.title = contact.title
    } else {
      this.setTitle(contact.type)
    }

    if (this.networkCategoryList.find(item => item.value === contact.type) !== undefined) {
      this.contactCategory = 'network'
      options.network = {
        value: contact.value,
        type: contact.type
      }
    } else if (!contact.type || contact.type == 'address') {
      this.contactCategory = 'address'
      options.address = {...contact}
    } else {
      this.contactCategory = contact.type

      options[contact.type] = contact.value
      options.phone = contact.value
    }
    options = {...options,
      badge: this.badge,
      contactId: this.contactId,
      contactCategory: this.contactCategory,
      title: this.title,
      isCurrentCompany: this.isCurrentCompany
    }
    this.setOptions(options)
    this.SetTitleDialog(this.$t('profile.contacts.form.edit_contact'))
    this.SetFormSDialog('EditContactForm')
    this.SetFullDialogShow(true)
  }

  onDelete(item: Contact) {
    this.$emit('onDelete', item)
  }

  toUpperCase(item: string) {
    return item.toUpperCase()
  }

  printContactCategoryByType(type: string) {
    return (this.contactCategoryList.find(item => item.value == type) as any).title
  }

  printAddress(item: any) {
    let address = []

    if (item.postcode !== 'undefined' && item.postcode !== '') {
      address.push(item.postcode)
    }

    if (item._country && item._country !== 'undefined' && item._country !== 'null') {
      let country = this.countries.find((country: any) => country.value === this.toUpperCase(item._country))
      if(country) address.push(country.title)
    }

    if (item.city !== 'undefined' && item.city !== '') {
      address.push(item.city)
    }

    if (item.address !== 'undefined' && item.address !== '') {
      address.push(item.address)
    }

    return address.join(', ')
  }

  setTitle(value: string) {

    const category: any = this.contactCategoryList.find(cat => cat.value === value)
    if (category) {
      if (category.value === 'address') {
        this.title = this.address.title = category.subtitle
      } else {
        this.title = category.title
      }
    }
  }
}
